export var getTypographyType = (textType, isBold, isSmallScreen) => {
  switch (textType) {
    case 'title':
      return isBold ? "body-single-line-" + (isSmallScreen ? 'md' : 'lg') + "-bold" : "title-single-line-" + (isSmallScreen ? 'md' : 'lg');
    case 'subtitle':
    case 'description':
      return "body-para-" + (isSmallScreen ? 'xs' : 'sm');
    case 'subtext':
      return "body-para-" + (isSmallScreen ? 'sm' : 'md');
    default:
      return;
  }
};